import illustrationTree from "../../assets/images/svg/Illustration_tree.svg";
import userIcon from "../../assets/images/svg/users.svg";
import userSettingsIcon from "../../assets/images/svg/userSettings.svg";
import growthIcon from "../../assets/images/svg/growth.svg";
import benchmarksIcon from "../../assets/images/svg/benchmarks.svg";
import familyMembersIcon from "../../assets/images/svg/family_members.svg";
import assetsGroupIcon from "../../assets/images/svg/assets_group.svg";
import illustrationTrack from "../../assets/images/svg/Illustration_track_wealth.svg";
import performaceIcon from "../../assets/images/svg/performance.svg";
import smallEllipse from "../../assets/images/svg/smallellipse.svg";
import bigEllipse from "../../assets/images/svg/bigellipse.svg";
import person1 from "../../assets/images/png/person1.png";
import person2 from "../../assets/images/png/person2.png";
import person3 from "../../assets/images/png/person3.png";
import Header from "../../components/Header/Header";
import unilever from "../../assets/images/png/unilever.png";
import vi from "../../assets/images/png/vi.png";
import zee from "../../assets/images/png/zee.png";
import hdfc from "../../assets/images/png/hdfc.png";
import divis from "../../assets/images/png/divis.png";
import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
//import { homePageRoute } from "../../utils/constants";
import { Link } from "react-router-dom";
import ArrowLink from "../../components/ArrowButton/ArrowLink";
//import { getOffshoreData } from "../../utils/functions";
//import { OFFSHORE } from "../../utils/constants";
import withHomePageLink from "../../hocs/withHomePageLink";

const logosArray = [
  { displayImage: unilever, id: 1 },
  { displayImage: zee, id: 2 },
  { displayImage: vi, id: 3 },
  { displayImage: hdfc, id: 4 },
  { displayImage: divis, id: 5 },
  { displayImage: unilever, id: 6 },
  { displayImage: zee, id: 7 },
  { displayImage: vi, id: 8 },
  { displayImage: hdfc, id: 9 },
  { displayImage: divis, id: 10 },
  { displayImage: unilever, id: 11 },
  { displayImage: zee, id: 12 },
  { displayImage: vi, id: 13 },
  { displayImage: hdfc, id: 14 },
  { displayImage: divis, id: 15 },
  { displayImage: unilever, id: 16 },
  { displayImage: zee, id: 17 },
  { displayImage: vi, id: 18 },
  { displayImage: hdfc, id: 19 },
  { displayImage: divis, id: 20 },
];

const UIWithAnnouncement = ({ ariaLabel, children }) => {
  return (
    <>
      <span className="sr-only">{ariaLabel}</span>
      {children}
    </>
  );
};

const SkipLink = withHomePageLink(({ navigateTo, stateObj }) => {
  return (
    <Link
      to={navigateTo}
      aria-label="Skip and Go to Home Page"
      className="skip_btn"
      state={stateObj.state}
    >
      Skip
    </Link>
  );
});

const HomePageArrowLink = withHomePageLink(({ navigateTo, stateObj }) => {
  return (
    <ArrowLink
      disabled={false}
      type={"next"}
      label={"Get Started"}
      navigateTo={navigateTo}
      stateObj={stateObj}
      ariaLabel={"Get Started Home Page"}
    />
  );
});

const AboutUs = () => {
  const [announcementMessage, setAnnouncementMessage] = useState("");

  useEffect(() => {
    setAnnouncementMessage("About us page loaded");
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageTitle title={"About Us"} />
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {announcementMessage}
      </div>
      <Header isLogoNavigationEnabled={true} />
      <div className="about_us_background" role={"main"}>
        <div className="page_container">
          <div className="go_back_skip_container">
            <ArrowLink
              disabled={false}
              type={"previous"}
              label={"Go Back"}
              navigateTo={"/welcome"}
              ariaLabel={"Go Back to Welcome Page"}
            />
            <SkipLink />
          </div>
          <div className="aboutus__first_container">
            <div className="illustrator_tree_wrapper">
              <img src={illustrationTree} alt="tree illustration" />
            </div>
            <div className="few_more_things_wrapper">
              <div className="few_more_text">
                A few more things <br />
                <PageHeading headingClass="" headingText="about us" />
              </div>
            </div>
            <div className="wealth_management_wrapper">
              <UIWithAnnouncement
                ariaLabel={
                  "We are one of the largest Wealth Management firm in India"
                }
              >
                <div aria-hidden={true} className="wealth_management_text">
                  We are <span>one of the largest</span> Wealth Management{" "}
                  <br /> firm in India
                </div>
              </UIWithAnnouncement>
            </div>
            <div className="three_cards_wrapper">
              <div className="card">
                <img src={userIcon} alt="" />
                <UIWithAnnouncement ariaLabel="We are ranked Best Private Bank, India by Global Finance Magzine for Family Offices since 2018">
                  <p className="card_text" aria-hidden={true}>
                    We are ranked{" "}
                    <span>
                      Best Private
                      <br /> Bank, India
                    </span>{" "}
                    by Global
                    <br />
                    Finance Magzine for Family <br />
                    Offices since 2018
                  </p>
                </UIWithAnnouncement>
              </div>
              <div className="card">
                <img src={growthIcon} alt="" />
                <UIWithAnnouncement ariaLabel="Our AUA has grown at 43% CAGR between FY14-FY22">
                  <p className="card_text" aria-hidden={true}>
                    Our AUA has grown at{" "}
                    <span>
                      43% <br />
                      CAGR
                    </span>{" "}
                    between FY14-FY22
                  </p>
                </UIWithAnnouncement>
              </div>
              <div className="card">
                <img src={userSettingsIcon} alt="" />
                <UIWithAnnouncement ariaLabel="We have presence in 8 cities of India but today we manage and service clients in more than 100 cities">
                  <p className="card_text" aria-hidden={true}>
                    We have presence in <span>8</span> cities
                    <br /> of India but today we
                    <br /> manage and service clients in
                    <br /> more than <span>100</span> cities
                  </p>
                </UIWithAnnouncement>
              </div>
            </div>
          </div>
          <div className="track_health_wrapper">
            <p>
              We help you track your wealth in{" "}
              <span>multiple different ways</span>
            </p>
            <div className="cards_side_img_grid_container">
              <div className="four_cards_wrapper">
                <div className="card">
                  <img src={familyMembersIcon} alt="" />
                  <p className="card_text">
                    By <span>Family Member</span>
                  </p>
                </div>
                <div className="card">
                  <img src={assetsGroupIcon} alt="" />
                  <p className="card_text">
                    By <span>Asset Class</span>
                  </p>
                </div>
                <div className="card">
                  <img src={performaceIcon} alt="" />
                  <p className="card_text">
                    By <span>Performance</span>
                  </p>
                </div>
                <div className="card">
                  <img src={benchmarksIcon} alt="" />
                  <p className="card_text">
                    Against <span>Benchmarks</span>
                  </p>
                </div>
              </div>
              <div className="side_img_wrapper">
                <img src={illustrationTrack} alt="Track wealth" />
              </div>
            </div>
          </div>
          <div className="research_team_text">
            <UIWithAnnouncement
              ariaLabel={
                "Our research team keeps you updated, with 200+ stocks under their watch"
              }
            >
              <p aria-hidden={true}>
                Our research team keeps you updated, <br />{" "}
                <span>with 200+ stocks under their watch</span>
              </p>
            </UIWithAnnouncement>
          </div>
          {/* <div className="all_companies_bg"></div> */}
          {/* <div className="company_logo_carousal1">
            <Marquee>
              <div className="marquee_image_wrapper">
                <img src={unilever} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={zee} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={vi} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={hdfc} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={divis} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={unilever} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={zee} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={vi} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={hdfc} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={divis} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={unilever} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={zee} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={vi} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={hdfc} alt="" />
              </div>
              <div className="marquee_image_wrapper">
                <img src={divis} alt="" />
              </div>
            </Marquee>

            <div style={{ marginTop: "10px" }}>
              <Marquee>
                <div className="marquee_image_wrapper1">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={divis} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={divis} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={divis} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={divis} alt="" />
                </div>
              </Marquee>
            </div>

            <div style={{ marginTop: "10px" }}>
              <Marquee>
                <div className="marquee_image_wrapper2">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={divis} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={divis} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper2">
                  <img src={divis} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={unilever} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={zee} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={vi} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={hdfc} alt="" />
                </div>
                <div className="marquee_image_wrapper1">
                  <img src={divis} alt="" />
                </div>
              </Marquee>
            </div>
          </div> */}
          <div className="company_logo_carousal1">
            <Marquee pauseOnHover>
              <div>
                <div
                  style={{ marginTop: "10px", display: "flex" }}
                  className="marquee_container marquee-1"
                >
                  {logosArray.map((logo) => (
                    <div
                      key={logo.id}
                      className="marquee_image_wrapper-1 marquee-common"
                    >
                      <img src={logo.displayImage} alt="" />
                    </div>
                  ))}
                </div>
                <div
                  style={{ marginTop: "10px", display: "flex" }}
                  className="marquee_container marquee-2"
                >
                  {logosArray.map((logo) => (
                    <div
                      key={logo.id}
                      className="marquee_image_wrapper1-1 marquee-common"
                    >
                      <img src={logo.displayImage} alt="" />
                    </div>
                  ))}
                </div>
                <div
                  style={{ marginTop: "10px", display: "flex" }}
                  className="marquee_container marquee-3"
                >
                  {logosArray.map((logo) => (
                    <div
                      key={logo.id}
                      className="marquee_image_wrapper2-1 marquee-common"
                    >
                      <img src={logo.displayImage} alt="" />
                    </div>
                  ))}
                </div>
              </div>{" "}
            </Marquee>
          </div>
          <div className="human_touch_wrapper">
            <p>
              And for us, the human touch, <span>is non-negotiable</span>
            </p>
            <img className="small_ellipse" src={smallEllipse} alt="ellipse" />
            <img className="big_ellipse" src={bigEllipse} alt="ellipse" />
            <div className="person1_wrapper">
              <img src={person1} alt="client" />
              <UIWithAnnouncement
                ariaLabel={"They focus on scheduled portfolio review meetings"}
              >
                <p aria-hidden={true}>
                  They focus on <br />{" "}
                  <span>
                    {" "}
                    scheduled portfolio <br />
                    review meetings
                  </span>
                </p>
              </UIWithAnnouncement>
            </div>
            <div className="person2_wrapper">
              <img src={person2} alt="client" />
              <UIWithAnnouncement
                ariaLabel={"Your financial advisors are a single call away"}
              >
                <p aria-hidden={true}>
                  Your financial advisors <br />
                  are a <span> single call away </span>
                </p>
              </UIWithAnnouncement>
            </div>
            <div className="person3_wrapper">
              <img src={person3} alt="client" />
              <UIWithAnnouncement ariaLabel={"They give you unbiased advice"}>
                <p aria-hidden={true}>
                  They give you <br /> <span> unbiased advice</span>
                </p>
              </UIWithAnnouncement>
            </div>
          </div>
          <div className="bottom_navigation">
            <HomePageArrowLink />
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
